import cn from 'classnames';
import { type IReactMultiEmailProps, ReactMultiEmail, isEmail } from 'react-multi-email';
import { Tag } from '../tag';

type P = { allowInvalidValues?: boolean; validateValue?: (value: string) => boolean } & {
  getLabel?: IReactMultiEmailProps['getLabel'];
  value?: IReactMultiEmailProps['emails'];
} & Omit<IReactMultiEmailProps, 'emails' | 'getLabel' | 'validateEmail'>;

const MultiValueInput = ({ allowInvalidValues, validateValue = isEmail, value, ...rest }: P) => (
  <ReactMultiEmail
    className="ui-multi-value-input"
    emails={value}
    getLabel={(inputValue: string, index: number, removeValue: (index: number) => void) => (
      <Tag
        className={cn('ui-multi-value-input_tag', {
          'ui-multi-value-input_tag__wrong-value': allowInvalidValues && !validateValue(inputValue),
        })}
        closable
        key={inputValue}
        onClose={() => {
          removeValue(index);
        }}
      >
        {inputValue}
      </Tag>
    )}
    validateEmail={(inputValue) => (allowInvalidValues ? true : validateValue(inputValue))}
    {...rest}
  />
);

export default MultiValueInput;
